import { VALIDATIONS, buildValidation } from '~utils/inputValidations';

import { FIELDS } from './constants';

export const validationSchema = buildValidation({
  [FIELDS.papaCarLicensePlate]: VALIDATIONS.licensePlate,
  [FIELDS.papaCarDescription]: VALIDATIONS.carDescription
});

export const getStoreKey = ({ hotspot: isHotspot, id, ...store }) =>
  isHotspot ? `hotspot-${store?.hotspotId}` : `store-${id}`;

export const storesKeyMatch = (storeX, storeY) =>
  storeX && storeY && getStoreKey(storeX) === getStoreKey(storeY);
